/**
 * Deep-link helpers for Kai rate-comparison artifacts, adapted to frontend-v2.
 *
 * v2 only has the `/rates` list (with a sessionStorage-backed PropertyFilter)
 * and `/rates/:cardId` detail — there is no Rate Lookup or Optimization view.
 * "Open in Rates" therefore writes `/rates?carrier=&contract_ref=` so
 * RatesPage hydrates the same property-filter bar.
 */

import { buildRatesFilterUrl } from "@/lib/ratesFilterLink";
import type { KaiRateFamily } from "./kaiTypes";

/**
 * Persist carrier / contract filters for the Rates list and return `/rates?…`.
 * Returns `null` when the family carries no usable filter context.
 */
export function buildFamilyRatesUrl(family: KaiRateFamily): string | null {
  const carrier = family.carrier;
  const contractRef = family.rows.find((row) => row.contract_ref)?.contract_ref;

  if (!carrier && !contractRef) {
    return family.open_in_rates_url ?? null;
  }

  return buildRatesFilterUrl({
    carrier,
    contract_ref: contractRef,
  });
}

/** Rate-card detail link for a row, when a card id is present. */
export function buildRateCardUrl(rateCardId?: string): string | null {
  return rateCardId ? `/rates/${encodeURIComponent(rateCardId)}` : null;
}
